import { buildSuppliersTableColumnConfiguration } from '../utils/buildSuppliersTableColumnConfiguration'

export const defaultSuppliersTableColumnConfiguration = buildSuppliersTableColumnConfiguration({
  excludedColumnKeys: [],
})
